// BAB micro-hover (safe)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.bab-home .tile[data-hx]').forEach(tile => {
    tile.addEventListener('pointermove', (e) => {
      const r = tile.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width - 0.5) * 6;
      const y = ((e.clientY - r.top) / r.height - 0.5) * 6;
      tile.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    }, { passive: true });

    tile.addEventListener('pointerleave', () => {
      tile.style.transform = '';
    });
  });
});
